module.exports = __webpack_public_path__ + "img/product-banner3.2d988e46.jpg";